module.exports = __webpack_public_path__ + "static/media/logo.616a96e1.png";